/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  Button,
  Row,
  Col,
  Form,
  Select,
  DatePicker,
  Pagination,
  Card,
  Space,
  notification,
  Tag,
  Table,
  Checkbox,
  Badge,
  Tooltip,
  Popconfirm,
} from "antd";
import { DeleteOutlined, EyeFilled, PlusOutlined } from "@ant-design/icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Loader from "../../../components/common/Loader";
import Search from "antd/es/input/Search";
import {
  deleteLeadService,
  getLeadsListingService,
} from "../../../services/admin-services";
import axios from "axios";
import { fetchLeadDetailsServices } from "../../auth/slice/authSlice";
import { approveRejectFinalInspectionService } from "../../../services/master-services";
import {
  getEnquirySourcesService,
  getFilterAreaService,
  getFilterTerritoriesService,
  getLeadFiltersLeadRange,
  getLeadOwnerService,
  getLeadService,
  getLeadStagesService,
  getLeadStatusService,
  getVehicleModelService,
  getLeadExchangeStageService,
  getFileStagesService,
} from "../../../services/master-services";
import { API_BASE_URL, API_RESPONSE_CODES } from "../../../utills/constant";

import { useSelector } from "react-redux";
import NoDataFound from "../../../components/common/NoDataFound";
import ModalComponent from "../../../components/modals/ModalComponent";
import { leadsInitialState } from "../../../utills/constant";
import { ddmmyyFormatter, openLeadViewInNewWindow } from "../../../utills/helpers";
import dayjs from "dayjs";
const { Option } = Select;
const { RangePicker } = DatePicker;

const Leads = () => {
  const [form] = Form.useForm();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const searchParams = new URLSearchParams(location.search);

  const hotKeyId = searchParams.get("key");
  const typeParamId = searchParams.get("lead_type");
  const graphMetricsId = searchParams.get("metrics");
  const graphValue = searchParams.get("graph_value");
  const stageParamId = searchParams.get("lead_stage");
  const statusParamId = searchParams.get("lead_status");
  const sourceParamId = searchParams.get("lead_source");
  const graphDuration = searchParams.get("graph_duration");
  const followUpDateParamId = searchParams.get("follow_up_date_id");
  const userTransferParams = searchParams.get("transfer");
  const testDriveParam = searchParams.get("test_drive_completed");
  const homeVisitParam = searchParams.get("home_visit_completed");
  const exchangeCarParam = searchParams.get("exchange_car");
  const evaluationCompletedParam = searchParams.get("evaluation_completed");
  const taskAgeingOneDay = searchParams.get("greater_than_one_day");
  const taskAgeingTenDay = searchParams.get("greater_than_ten_day");
  const taskAgeingTwentyDay = searchParams.get("greater_than_twenty_day");
  const lineGraphLastMonth = searchParams.get("last_month");
  const isLastMonthParam =
    lineGraphLastMonth === "true" || lineGraphLastMonth === '"true"';
  const territoryIdParam = searchParams.get("territory_id");
  const targeRedirectParam = searchParams.get("target_redirect");
  const excludeIdQueryParams = searchParams.get("exclude_user_ids");
  const procuredQueryParams = searchParams.get("procured");
  const modelIdParam = searchParams.get("model_id");
  // Support array-style params like area_id[0]=6
  const areaIdsFromParams = [];
  for (const [key, value] of searchParams.entries()) {
    if (key.startsWith("area_id[")) areaIdsFromParams.push(value);
  }
  const areaIdParam = searchParams.get("area_id");
  const leadFunnelRedirect = searchParams.get("lead_funnel_redirect");
  const unevaluatedParam = searchParams.get("unevaluated_leads");
  const isUnevaluated = unevaluatedParam === "1" || unevaluatedParam === "true";
  const approvalPendingForFinalInspectionParam = searchParams.get(
    "approval_pending_for_final_inspection"
  );
  const isApprovalPendingForFinalInspection =
    approvalPendingForFinalInspectionParam === "1" ||
    approvalPendingForFinalInspectionParam === "true";
  const leadExchangeStageId = searchParams.get("lead_exchange_stage_id");
  const leadExchangeStageName = searchParams.get("lead_exchange_stage_name");
  const exchangeOfficerIdParam = searchParams.get("exchange_officer_id");
  const exchangeOfficerNameParam = searchParams.get("exchange_officer_name");
  const startDateParam = searchParams.get("start_date");
  const endDateParam = searchParams.get("end_date");
  const currentMonthParam = searchParams.get("current_month");
  const dashboardRedirectParam = searchParams.get("dashboard_redirect");
  const liveBookingRedirectParam = searchParams.get("live_booking_redirect");
  const liveBookingCategoryParam = searchParams.get("live_booking_category");
  const mtdBookingRedirectParam = searchParams.get("mtd_booking_redirect");
  const areaNameParam = searchParams.get("area_name");
  const isLiveBookingRedirect =
    liveBookingRedirectParam === "true" || liveBookingRedirectParam === "1";
  const isMtdBookingRedirect =
    mtdBookingRedirectParam === "true" || mtdBookingRedirectParam === "1";
  const isDashboardTableRedirect = isLiveBookingRedirect || isMtdBookingRedirect;
  const shouldUseDashboardDateFallback =
    hotKeyId && !isDashboardTableRedirect;
  const showRedirectTags = hotKeyId || isDashboardTableRedirect;
  const documentCollectionPendingParam = searchParams.get("document_collection_pending");
  const deliveryApprovalPendingParam = searchParams.get("delivery_approval_pending");

  const excludeIdArray = excludeIdQueryParams
    ?.split(",")
    ?.map((item) => parseInt(item?.trim(), 10));

  const dashboardData = useSelector(
    (state) => state?.auth?.dashboardHomeFilters
  );
  const route = useSelector((state) => state?.auth?.route);
  const isAdmin = useSelector((state) => state?.auth?.isAdmin);
  const permissions = useSelector((state) => state.auth.userData.permissions);
  const roleType = useSelector((state) => state?.auth?.userData?.role);
  const isBackOfficeManager = roleType === "Back Office Manager" ||  roleType === 'Head Office Manager';

  // Collect model type from URL: supports both model_type and array-style model_type[0]
  const modelTypeArrayFromParams = [];
  for (const [key, value] of searchParams.entries()) {
    if (key.startsWith("model_type[")) modelTypeArrayFromParams.push(value);
  }
  const modelTypeSingleParam =
    searchParams.get("model_type") || searchParams.get("model_no");
  const modelType = dashboardData?.modelNo || modelTypeSingleParam;
  const userType = dashboardData?.userId;
  // Format dates to YYYY-MM-DD format
  const formatDateToYYYYMMDD = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    return date.toISOString().split("T")[0]; // Returns YYYY-MM-DD format
  };

  const startDateId = formatDateToYYYYMMDD(dashboardData?.startDate);
  const endDateId = formatDateToYYYYMMDD(dashboardData?.endDate);
  const exclude_user_ids = dashboardData?.exclude_user_ids
    ? dashboardData?.exclude_user_ids
    : "";
  const monthID = targeRedirectParam ? dashboardData?.month_id : "";
  const year = targeRedirectParam ? dashboardData?.year_id : "";
  const leadOwned = searchParams.get("lead_owned");
  const kpiParameterTargetQuery = searchParams.get("kpi_parameter");
  const kpiParamVasBookEw = searchParams.get("kpi_parameter_ew");
  const kpiParamVasBookbody = searchParams.get("kpi_parameter_body_care");
  const kpiParamVasBookaccess = searchParams.get("kpi_parameter_accessories");
  const kpiParamVasBookinhouse = searchParams.get("kpi_parameter_in_house");
  const vasReportQueryParam = searchParams.get("vas_report_redirect");
  const vasReportRetailQueryParam = searchParams.get(
    "vas_report_redirect_retail"
  );
  const isBookingCompleted = searchParams.get("booking_completed");

  const [rtoData, setRtoData] = useState([]);
  const [tagNames, setTagnames] = useState({});
  const [fuelData, setFuelData] = useState([]);
  // hasMenuFilter: true only for menu clicks (lead_exchange_stage_id, unevaluated_leads, approval_pending_for_final_inspection)
  // NOT for regular filter changes (lead_status, lead_type, model_type, etc.)
  const hasMenuFilter = Boolean(
    leadExchangeStageId || isUnevaluated || isApprovalPendingForFinalInspection
  );

  const [filters, setFilters] = useState({
    per_page: 10,
    page: 1,
    search: "",
    lead_status: statusParamId ? [statusParamId] : [],
    lead_type: typeParamId && +typeParamId !== 10 ? [typeParamId] : [],
    lead_stage: stageParamId ? [stageParamId] : [],
    model_type: modelTypeArrayFromParams.length
      ? modelTypeArrayFromParams
      : hotKeyId && modelType
      ? [modelType]
      : modelIdParam
      ? [modelIdParam]
      : [],
    fuel_type: [],
    rto_locations: [],
    lead_sources: sourceParamId ? [sourceParamId] : [],
    variant_type: [],
    state_id: [],
    territory_id: territoryIdParam ? [territoryIdParam] : [],
    area_id: areaIdsFromParams.length
      ? areaIdsFromParams
      : areaIdParam
      ? [areaIdParam]
      : [],
    lead_owned: userTransferParams
      ? [userTransferParams]
      : hotKeyId && leadOwned
      ? [leadOwned]
      : hotKeyId && userType
      ? [userType]
      : [],
    follow_up_date_id: followUpDateParamId ? [followUpDateParamId] : [],
    start_date: startDateParam
      ? startDateParam
      : shouldUseDashboardDateFallback && startDateId
      ? startDateId
      : "",
    end_date: endDateParam
      ? endDateParam
      : shouldUseDashboardDateFallback && endDateId
      ? endDateId
      : "",
    graph_metrics: hotKeyId && graphMetricsId ? graphMetricsId : "",
    date_range: hotKeyId && graphDuration ? graphDuration : "",
    test_drive_completed: testDriveParam === `"true"` ? true : false,
    home_visit_completed: homeVisitParam === `"true"` ? true : false,
    exchange_car: exchangeCarParam === `"true"` ? true : false,
    evaluation_completed: evaluationCompletedParam === `"true"` ? true : false,
    greater_than_one_day: taskAgeingOneDay === `"true"` ? true : false,
    greater_than_ten_day: taskAgeingTenDay === `"true"` ? true : false,
    greater_than_twenty_day: taskAgeingTwentyDay === `"true"` ? true : false,
    last_month: isLastMonthParam ? true : false,
    live_lead: typeParamId === "10" ? true : false,
    dashboard_redirect: isDashboardTableRedirect
      ? false
      : hotKeyId &&
        (dashboardRedirectParam === "true" || dashboardRedirectParam === "1")
      ? true
      : hasMenuFilter
      ? true
      : hotKeyId &&
        (userType || startDateId || endDateId || dashboardData?.modelNo) &&
        !userTransferParams
      ? true
      : false,
    exclude_user_ids: excludeIdArray
      ? excludeIdArray
      : exclude_user_ids
      ? exclude_user_ids
      : null,
    target_redirect: targeRedirectParam ? true : false,
    unevaluated_leads: isUnevaluated ? 1 : null,
    approval_pending_for_final_inspection: isApprovalPendingForFinalInspection
      ? 1
      : null,
    lead_exchange_stage_id: leadExchangeStageId ? leadExchangeStageId : null,
    exchange_officer_id: exchangeOfficerIdParam ? exchangeOfficerIdParam : "",
    month: monthID,
    year: year,
    kpi_parameter: kpiParameterTargetQuery
      ? "booking"
      : kpiParamVasBookEw
      ? "ew"
      : kpiParamVasBookbody
      ? "body_care"
      : kpiParamVasBookaccess
      ? "accessories"
      : kpiParamVasBookinhouse
      ? "inhouse"
      : "",
    procured: procuredQueryParams ? true : "",
    vas_report_redirect: vasReportQueryParam
      ? "booking"
      : vasReportRetailQueryParam
      ? "retail"
      : "",
    booking_completed: isBookingCompleted === `"true"` ? true : false,
    lead_funnel_redirect: leadFunnelRedirect === "true" ? true : false,
    current_month:
      currentMonthParam === "true" || currentMonthParam === "1" ? true : false,
    allocation_status: null,
    file_stage_id: null,
    document_collection_pending: documentCollectionPendingParam === "true" ? true : false,
    delivery_approval_pending: deliveryApprovalPendingParam === "true" ? true : false,
    live_booking_redirect: isLiveBookingRedirect,
    live_booking_category: liveBookingCategoryParam || "",
    mtd_booking_redirect: isMtdBookingRedirect,
  });

  // When menu query params change while staying on the same page, push them into filters and reset other filters
  // Watch location.search to detect any URL changes (including navigation to clean URL)
  useEffect(() => {
    // Check if URL has any meaningful params (not just empty search)
    const hasUrlParams = location.search && location.search.length > 0;
    
    // Don't reset filters if this is a dashboard redirect - keep the filters from the redirect
    const isDashboardRedirect =
      isDashboardTableRedirect ||
      (hotKeyId &&
        (dashboardRedirectParam === "true" ||
          dashboardRedirectParam === "1")) ||
      (hotKeyId &&
        (userType || startDateId || endDateId || dashboardData?.modelNo) &&
        !userTransferParams);

    if (isDashboardRedirect) {
      // For dashboard redirects, don't reset filters - they should already be set correctly
      return;
    }

    // If no URL params (clean URL), reset all filters to defaults
    if (!hasUrlParams) {
      setFilters({
        per_page: 10,
        page: 1,
        search: "",
        lead_status: [],
        lead_type: [],
        lead_stage: [],
        model_type: [],
        fuel_type: [],
        rto_locations: [],
        lead_sources: [],
        variant_type: [],
        state_id: [],
        territory_id: [],
        area_id: [],
        lead_owned: [],
        follow_up_date_id: [],
        start_date: "",
        end_date: "",
        graph_metrics: "",
        date_range: "",
        test_drive_completed: false,
        home_visit_completed: false,
        exchange_car: false,
        evaluation_completed: false,
        greater_than_one_day: false,
        greater_than_ten_day: false,
        greater_than_twenty_day: false,
        last_month: false,
        live_lead: false,
        dashboard_redirect: false,
        exclude_user_ids: null,
        target_redirect: false,
        unevaluated_leads: null,
        approval_pending_for_final_inspection: null,
        lead_exchange_stage_id: null,
        exchange_officer_id: "",
        month: "",
        year: "",
        kpi_parameter: "",
        procured: "",
        vas_report_redirect: "",
        booking_completed: false,
        lead_funnel_redirect: false,
        current_month: false,
        allocation_status: null,
        file_stage_id: null,
        document_collection_pending: false,
        delivery_approval_pending: false,
        live_booking_redirect: false,
        live_booking_category: "",
        mtd_booking_redirect: false,
      });
      // Reset form fields
      form.setFieldsValue({
        lead_status: undefined,
        lead_type: undefined,
        model_type: undefined,
        fuel_type: undefined,
        rto_locations: undefined,
        territory_id: undefined,
        area_id: undefined,
        lead_owned: undefined,
        lead_stage: undefined,
        lead_source: undefined,
        follow_up_date_id: undefined,
        allocation_status: undefined,
        file_stage: undefined,
        exchange_stage: undefined,
        date: undefined,
      });
      // Reset exchange stage filter
      setExchangeStageFilter(undefined);
      return;
    }

    // Reset filters when URL changes (menu tabs change or navigation with params)
    setFilters((prev) => ({
      ...prev,
      page: 1,
      per_page: 10,
      search: "", // Reset search
      lead_status: statusParamId ? [statusParamId] : [], // Set from URL or reset
      lead_type: typeParamId && +typeParamId !== 10 ? [typeParamId] : [], // Set from URL or reset
      lead_stage: stageParamId ? [stageParamId] : [], // Set from URL or reset
      model_type: modelTypeArrayFromParams.length
        ? modelTypeArrayFromParams
        : hotKeyId && modelType
        ? [modelType]
        : modelIdParam
        ? [modelIdParam]
        : [],
      live_booking_redirect: isLiveBookingRedirect,
      live_booking_category: liveBookingCategoryParam || "",
      mtd_booking_redirect: isMtdBookingRedirect,
      fuel_type: [], // Reset fuel type
      rto_locations: [], // Reset RTO locations
      lead_sources: sourceParamId ? [sourceParamId] : [], // Set from URL or reset
      territory_id: territoryIdParam ? [territoryIdParam] : [], // Set from URL or reset
      area_id: areaIdsFromParams.length
        ? areaIdsFromParams
        : areaIdParam
        ? [areaIdParam]
        : [], // Set from URL or reset
      lead_owned: userTransferParams
        ? [userTransferParams]
        : hotKeyId && leadOwned
        ? [leadOwned]
        : hotKeyId && userType
        ? [userType]
        : [], // Set from URL or reset
      follow_up_date_id: followUpDateParamId ? [followUpDateParamId] : [], // Set from URL or reset
      start_date: startDateParam
        ? startDateParam
        : shouldUseDashboardDateFallback && startDateId
        ? startDateId
        : "", // Set from URL or reset
      end_date: endDateParam
        ? endDateParam
        : shouldUseDashboardDateFallback && endDateId
        ? endDateId
        : "", // Set from URL or reset
      graph_metrics: hotKeyId && graphMetricsId ? graphMetricsId : "", // Set from URL or reset
      date_range: hotKeyId && graphDuration ? graphDuration : "", // Set from URL or reset
      test_drive_completed: testDriveParam === `"true"` ? true : false, // Set from URL or reset
      home_visit_completed: homeVisitParam === `"true"` ? true : false, // Set from URL or reset
      exchange_car: exchangeCarParam === `"true"` ? true : false, // Set from URL or reset
      evaluation_completed: evaluationCompletedParam === `"true"` ? true : false, // Set from URL or reset
      greater_than_one_day: taskAgeingOneDay === `"true"` ? true : false, // Set from URL or reset
      greater_than_ten_day: taskAgeingTenDay === `"true"` ? true : false, // Set from URL or reset
      greater_than_twenty_day: taskAgeingTwentyDay === `"true"` ? true : false, // Set from URL or reset
      last_month: isLastMonthParam ? true : false, // Set from URL or reset
      live_lead: typeParamId === "10" ? true : false, // Set from URL or reset
      allocation_status: null, // Reset allocation status
      file_stage_id: null, // Reset file stage
      document_collection_pending: documentCollectionPendingParam === "true" ? true : false, // Set from URL or reset
      delivery_approval_pending: deliveryApprovalPendingParam === "true" ? true : false, // Set from URL or reset
      // Keep menu-specific parameters
      lead_exchange_stage_id: leadExchangeStageId ? leadExchangeStageId : null,
      unevaluated_leads: isUnevaluated ? 1 : null,
      approval_pending_for_final_inspection: isApprovalPendingForFinalInspection
        ? 1
        : null,
      current_month:
        currentMonthParam === "true" || currentMonthParam === "1"
          ? true
          : false,
      // Only set dashboard_redirect to true for dashboard redirects, NOT for menu clicks
      dashboard_redirect: false,
    }));
    // Reset form fields when URL changes
    form.setFieldsValue({
      lead_status: undefined,
      lead_type: undefined,
      model_type: undefined,
      fuel_type: undefined,
      rto_locations: undefined,
      territory_id: undefined,
      area_id: undefined,
      lead_owned: undefined,
      lead_stage: undefined,
      lead_source: undefined,
      follow_up_date_id: undefined,
      allocation_status: undefined,
      file_stage: undefined,
      exchange_stage: getCurrentExchangeStageValue(),
      date:
        startDateParam && endDateParam
          ? [dayjs(startDateParam), dayjs(endDateParam)]
          : undefined,
    });
    // Update exchange stage filter state
    setExchangeStageFilter(getCurrentExchangeStageValue());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]); // Watch entire URL search string to detect any changes

  // State for Exchange Stage filter (instead of URL params for user selections)
  const [exchangeStageFilter, setExchangeStageFilter] = useState(undefined);

  const [areaData, setAreaData] = useState([]);
  const [leadsData, setLeadsData] = useState([]);
  const [modalData, setModalData] = useState([]);
  const [ownerData, setOwnerData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [enquiryData, setEnquiryData] = useState([]);
  const [followUpData, setFollowUpData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [leadsTypeData, setLeadsTypeData] = useState([]);
  const [territoryData, setTerritoryData] = useState([]);
  const [leadStageData, setLeadStageData] = useState([]);
  const [leadStatusData, setLeadStatusData] = useState([]);
  const [exchangeStages, setExchangeStages] = useState([]);
  const [fileStageData, setFileStageData] = useState([]);
  const [transferLeadIds, setTransferLeadIds] = useState([]);
  const [vehicleIds, setVehicleIds] = useState({
    make_id: 1,
    model_id: "",
    variant_id: "",
  });
  const [register, setRegister] = useState({
    state_id: 0,
    territory_id: 0,
  });

  const hasLeadsData = leadsData?.list_data?.length > 0;
  const hasAddLeadPermission = isAdmin
    ? true
    : permissions?.includes("add-lead");
  const selectedLeadsLength = transferLeadIds?.length;
  const routeCheck = isAdmin ? "/admin" : "";

  // Add this state to track pending API requests
  const [pendingRequests, setPendingRequests] = useState(0);

  // Replace the existing setIsLoading calls with these helper functions
  const startLoading = () => {
    setPendingRequests((prev) => prev + 1);
    setIsLoading(true);
  };

  const stopLoading = () => {
    setPendingRequests((prev) => {
      const newCount = prev - 1;
      if (newCount === 0) {
        setIsLoading(false);
      }
      return newCount;
    });
  };

  useEffect(() => {
    if (userTransferParams) {
      // getLeadListing(filters);
      setIsModalOpen(true);
    }
  }, [userTransferParams]);

  useEffect(() => {
    // getLeadListing(filters);
    getRTOData();
    getFuelData();
    getAreaData();
    getOwnerData();
    getEnquiryData();
    getLeadsTypeData();
    getTerritoryData();
    getLeadStagesData();
    getLeadStatusData();
    getExchangeStagesData();
    getFileStagesData();
    setTransferLeadIds([]);
    getLeadFilterDateData();
    getModalData(vehicleIds?.make_id);
  }, []);

  useEffect(() => {
    getLeadListing(filters);
  }, [filters]);

  useEffect(() => {
    if (hotKeyId && typeParamId) {
      const lead_type =
        typeParamId === "10"
          ? "Live"
          : leadsTypeData?.filter((ele) => ele.id === +typeParamId)?.at(0)
              ?.name;
      setTagnames((state) => ({
        ...state,
        "Lead Type": lead_type,
      }));
    }
    if (hotKeyId && stageParamId) {
      let val;
      if (+stageParamId === 11) {
        val = "Enquiry";
      } else if (+stageParamId === 12) {
        val = "Test Drive";
      } else if (+stageParamId === 13) {
        val = "Home Visit";
      } else if (+stageParamId === 14) {
        val = "Exchange";
      } else if (+stageParamId === 15) {
        val = "Valuation";
      } else {
        val = leadStageData
          ?.filter((ele) => ele.id === +stageParamId)
          ?.at(0)?.name;
      }
      setTagnames((state) => ({
        ...state,
        "Lead Stage": val,
      }));
    }
    if (hotKeyId && sourceParamId) {
      const source = enquiryData
        ?.filter((ele) => ele.id === +sourceParamId)
        ?.at(0)?.source;
      setTagnames((state) => ({
        ...state,
        "Lead Source": source,
      }));
    }

    // Add Area ID parameter
    const areaIdParam = searchParams.get("area_id");
    if (hotKeyId && areaIdParam) {
      const areaName = areaData
        ?.filter((ele) => ele.id === +areaIdParam)
        ?.at(0)?.name;
      if (areaName) {
        setTagnames((state) => ({
          ...state,
          Area: areaName,
        }));
      }
    }

    // Add Model ID parameter
    const modelIdParam = searchParams.get("model_id");
    if ((hotKeyId || isMtdBookingRedirect) && modelIdParam) {
      const modelName = modalData
        ?.filter((ele) => ele.id === +modelIdParam)
        ?.at(0)?.model_name;
      if (modelName) {
        setTagnames((state) => ({
          ...state,
          Model: modelName,
        }));
      }
    }
    if (hotKeyId && followUpDateParamId) {
      const followUp = followUpData
        ?.filter((ele) => ele.id === +followUpDateParamId)
        ?.at(0)?.title;
      setTagnames((state) => ({
        ...state,
        "Follow Up Date": followUp,
      }));
    }
    if (hotKeyId && statusParamId) {
      const status = leadStatusData
        ?.filter((ele) => ele.id === +statusParamId)
        ?.at(0)?.name;
      setTagnames((state) => ({ ...state, "Lead Status": status }));
    }
    if (hotKeyId && modelType) {
      const model = modalData
        ?.filter((ele) => ele.id === +modelType)
        ?.at(0)?.model_name;
      setTagnames((state) => ({ ...state, Model: model }));
    }
    if (hotKeyId && userType) {
      const owner = ownerData
        ?.filter((ele) => ele.id === +userType)
        ?.at(0)?.full_name;
      setTagnames((state) => ({ ...state, "Lead Owner": owner }));
    }
    if (hotKeyId && leadOwned) {
      const owner = ownerData
        ?.filter((ele) => ele.id === +leadOwned)
        ?.at(0)?.full_name;
      setTagnames((state) => ({ ...state, "Lead Owner": owner }));
    }
    if (userTransferParams && userTransferParams) {
      const owner = ownerData
        ?.filter((ele) => ele.id === +userTransferParams)
        ?.at(0)?.full_name;
      setTagnames((state) => ({ ...state, "Lead Owner": owner }));
    }
    if (shouldUseDashboardDateFallback && startDateId) {
      setTagnames((state) => ({
        ...state,
        "From Date": ddmmyyFormatter(startDateId),
      }));
    }
    if (shouldUseDashboardDateFallback && endDateId) {
      setTagnames((state) => ({
        ...state,
        "To Date": ddmmyyFormatter(endDateId),
      }));
    }
    if (hotKeyId && graphDuration) {
      const string =
        graphMetricsId === "variation"
          ? `${graphDuration}`
          : `${graphDuration} days`;
      setTagnames((state) => ({
        ...state,
        " Duration": string,
      }));
    }
    if (hotKeyId && testDriveParam === `"true"`) {
      setTagnames((state) => ({
        ...state,
        "Lead Stage": "Test Drive",
      }));
    }
    if (hotKeyId && homeVisitParam === `"true"`) {
      setTagnames((state) => ({
        ...state,
        "Lead Stage": "Home Visit",
      }));
    }
    if (hotKeyId && exchangeCarParam === `"true"`) {
      setTagnames((state) => ({
        ...state,
        "Lead Stage": "Exchange",
      }));
    }
    if (hotKeyId && evaluationCompletedParam === `"true"`) {
      setTagnames((state) => ({
        ...state,
        "Lead Stage": "Evaluation",
      }));
    }
    if (hotKeyId && taskAgeingOneDay === `"true"`) {
      setTagnames((state) => ({
        ...state,
        "Task Ageing": ">1 Day",
      }));
    }
    if (hotKeyId && taskAgeingTenDay === `"true"`) {
      setTagnames((state) => ({
        ...state,
        "Task Ageing": ">10 Days",
      }));
    }
    if (hotKeyId && taskAgeingTwentyDay === `"true"`) {
      setTagnames((state) => ({
        ...state,
        "Task Ageing": ">20 Days",
      }));
    }
    if (hotKeyId && territoryIdParam) {
      const territoryName = territoryData
        ?.filter((ele) => ele.id === +territoryIdParam)
        ?.at(0)?.name;
      setTagnames((state) => ({
        ...state,
        Territory: territoryName,
      }));
    }
    if (hotKeyId && leadFunnelRedirect === "true") {
      setTagnames((state) => ({
        ...state,
        "Lead Funnel": "Lead Stage",
      }));
    }
    if (hotKeyId && graphMetricsId) {
      let title;
      if (graphMetricsId === "lead_count") {
        title = "Lead Count";
      } else if (graphMetricsId === "quotation_sent") {
        title = "Quotation Sent";
      } else if (graphMetricsId === "pending_valuation") {
        title = "Pending valuation";
      } else if (graphMetricsId === "variation") {
        title = "Variation";
      }

      setTagnames((state) => ({ ...state, "Graph Metrics": `${title}` }));
    }

    // Add Exchange Stage parameter
    if (hotKeyId && leadExchangeStageId && leadExchangeStageName) {
      setTagnames((state) => ({
        ...state,
        "Exchange Stage": leadExchangeStageName,
      }));
    }

    // Add Exchange Evaluation Team parameter (prefer name from URL; fallback to lookup by id)
    if (hotKeyId && (exchangeOfficerNameParam || exchangeOfficerIdParam)) {
      const exchangeOfficer =
        exchangeOfficerNameParam ||
        ownerData?.filter((ele) => ele.id === +exchangeOfficerIdParam)?.at(0)
          ?.full_name;
      if (exchangeOfficer) {
        setTagnames((state) => ({
          ...state,
          "Exchange Evaluation Team": exchangeOfficer,
        }));
      }
    }

    // Add Start Date parameter
    if (shouldUseDashboardDateFallback && startDateParam) {
      setTagnames((state) => ({
        ...state,
        "From Date": ddmmyyFormatter(startDateParam),
      }));
    }

    // Add End Date parameter
    if (shouldUseDashboardDateFallback && endDateParam) {
      setTagnames((state) => ({
        ...state,
        "To Date": ddmmyyFormatter(endDateParam),
      }));
    }

    // Add Area parameter from Dashboard Exchange (area_id[0])
    if (
      (hotKeyId || isDashboardTableRedirect) &&
      areaIdsFromParams.length > 0
    ) {
      const areaNames = areaIdsFromParams
        .map((areaId) => {
          const area = areaData?.filter((ele) => ele.id === +areaId)?.at(0);
          return area?.name;
        })
        .filter(Boolean);

      if (areaNames.length > 0) {
        setTagnames((state) => ({
          ...state,
          Area: areaNames.join(", "),
        }));
      }
    }

    if (isMtdBookingRedirect && areaIdParam) {
      const areaName = areaData
        ?.filter((ele) => ele.id === +areaIdParam)
        ?.at(0)?.name;
      if (areaName) {
        setTagnames((state) => ({
          ...state,
          Area: areaName,
        }));
      }
    }

    if (isLiveBookingRedirect && areaNameParam) {
      setTagnames((state) => ({
        ...state,
        Area: areaNameParam,
      }));
    }

    if (isMtdBookingRedirect) {
      setTagnames((state) => ({
        ...state,
        Source: "MTD Booking",
      }));
    }

    if (isLiveBookingRedirect && liveBookingCategoryParam) {
      setTagnames((state) => ({
        ...state,
        Category:
          liveBookingCategoryParam.charAt(0).toUpperCase() +
          liveBookingCategoryParam.slice(1),
      }));
    }

    if (
      (hotKeyId || isDashboardTableRedirect) &&
      modelTypeArrayFromParams.length > 0
    ) {
      const modelNames = modelTypeArrayFromParams
        .map((modelId) => {
          const model = modalData?.filter((ele) => ele.id === +modelId)?.at(0);
          return model?.model_name;
        })
        .filter(Boolean);

      if (modelNames.length > 0) {
        setTagnames((state) => ({
          ...state,
          Model: modelNames.join(", "),
        }));
      }
    }

    // Add Procured parameter from Dashboard Exchange
    if (hotKeyId && procuredQueryParams) {
      setTagnames((state) => ({
        ...state,
        Status: "Procured",
      }));
    }

    // Add Document Collection Pending parameter
    if (hotKeyId && documentCollectionPendingParam === "true") {
      setTagnames((state) => ({
        ...state,
        "Task Type": "Pending Document Collection Requests",
      }));
    }

    // Add Delivery Approval Pending parameter
    if (hotKeyId && deliveryApprovalPendingParam === "true") {
      setTagnames((state) => ({
        ...state,
        "Task Type": "Pending Delivery Approval Requests",
      }));
    }
  }, [
    typeParamId,
    stageParamId,
    sourceParamId,
    testDriveParam,
    ownerData,
    modalData,
    enquiryData,
    followUpData,
    leadStageData,
    leadStatusData,
    leadsTypeData,
    graphMetricsId,
    graphDuration,
    userTransferParams,
    areaData, // Added for area filtering
    leadFunnelRedirect, // Added for lead funnel redirect
    leadExchangeStageId, // Added for exchange stage filtering
    leadExchangeStageName, // Added for exchange stage name
    exchangeOfficerIdParam, // Added for exchange officer filtering
    currentMonthParam, // Added for current month filtering
    isLastMonthParam, // Added for last month filtering
    startDateParam, // Added for start date filtering
    endDateParam, // Added for end date filtering
    areaIdsFromParams, // Added for area filtering from dashboard
    modelTypeArrayFromParams, // Added for model type filtering from dashboard
    procuredQueryParams, // Added for procured filtering from dashboard
    documentCollectionPendingParam, // Added for document collection pending filtering
    deliveryApprovalPendingParam, // Added for delivery approval pending filtering
  ]);

  useEffect(() => {
    if (!hotKeyId && !userTransferParams) {
      // setFilters({
      //   ...filters,
      //   ...leadsInitialState,
      // });
    }
  }, [hotKeyId]);

  const handleButtonClick = () => {
    navigate(`${routeCheck}/leads`);
    setFilters({
      ...filters,
      ...leadsInitialState,
    });
  };

  const getOwnerData = async () => {
    startLoading();
    try {
      const ownerData = await getLeadOwnerService();
      if (ownerData?.status === API_RESPONSE_CODES?.OK) {
        setOwnerData(ownerData?.data?.data);
      }
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    } finally {
      stopLoading();
    }
  };

  const getLeadStagesData = async () => {
    startLoading();
    try {
      const stateData = await getLeadStagesService();
      if (stateData?.status === API_RESPONSE_CODES?.OK) {
        setLeadStageData(stateData?.data?.data);
      }
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    } finally {
      stopLoading();
    }
  };

  const handleModalIdChange = (value) => {
    setFilters((state) => ({
      ...state,
      page: 1,
      model_type: value,
      dashboard_redirect: false, // Filter changes on page should not pass dashboard_redirect
    }));
    setVehicleIds((state) => ({
      ...state,
      model_id: value,
    }));

    form.setFieldsValue({
      vehicle_variant_id: undefined,
      color_id: undefined,
      fuel_type_id: undefined,
      seater_id: undefined,
    });
    // getVarientData(value);
  };

  const getEnquiryData = async () => {
    startLoading();
    try {
      const enquiryDataArray = await getEnquirySourcesService();
      if (enquiryDataArray?.status === API_RESPONSE_CODES?.OK) {
        setEnquiryData(enquiryDataArray?.data?.data);
      }
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    } finally {
      stopLoading();
    }
  };

  const handleTerritoryChange = (value) => {
    setFilters((state) => ({
      ...state,
      page: 1,
      territory_id: value,
      dashboard_redirect: false, // Filter changes on page should not pass dashboard_redirect
    }));

    setRegister((state) => ({
      ...state,
      territory_id: value,
    }));
    getAreaData(register.state_id, value);
  };

  const getLeadStatusData = async () => {
    startLoading();
    try {
      const response = await getLeadStatusService();
      if (response?.status === API_RESPONSE_CODES?.OK) {
        setLeadStatusData(response?.data?.data);
      }
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    } finally {
      stopLoading();
    }
  };

  const getExchangeStagesData = async () => {
    try {
      const response = await getLeadExchangeStageService();
      if (response?.data?.status === API_RESPONSE_CODES?.OK) {
        setExchangeStages(response?.data?.data || []);
      }
    } catch (error) {
      console.error("Error fetching exchange stages:", error);
    }
  };

  const getFileStagesData = async () => {
    startLoading();
    try {
      const response = await getFileStagesService();
      if (response?.status === API_RESPONSE_CODES?.OK) {
        setFileStageData(response?.data?.data || []);
      }
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    } finally {
      stopLoading();
    }
  };

  // Helper function to check if user should see Unallocated option
  const shouldShowUnallocated = () => {
    const salesTeamRoles = [
      "Super Admin",
      "CEO",
      "VP Sales",
      "GM (General Manager)",
      "AGM (Assistant General Manager)",
      "TSM (Territory Sales Manager)",
      "Sales Manager",
      "Team Leader",
      "Sales Officer",
    ];
    return salesTeamRoles.includes(roleType);
  };

  // Handler for Exchange Stages dropdown - uses state instead of URL navigation
  const handleExchangeStageChange = (value) => {
    // Update state
    setExchangeStageFilter(value);

    // Update filters state
    if (!value || value === "all_leads") {
      // Clear exchange stage filters
      setFilters((prev) => ({
        ...prev,
        page: 1,
        lead_exchange_stage_id: null,
        unevaluated_leads: null,
        approval_pending_for_final_inspection: null,
        last_month: false,
        current_month: false,
        dashboard_redirect: false,
      }));
    } else if (value === "pending_eval_prev_month") {
      setFilters((prev) => ({
        ...prev,
        page: 1,
        lead_exchange_stage_id: "1",
        unevaluated_leads: null,
        approval_pending_for_final_inspection: null,
        last_month: true,
        current_month: false,
        dashboard_redirect: false,
      }));
    } else if (value === "pending_eval_current_month") {
      setFilters((prev) => ({
        ...prev,
        page: 1,
        lead_exchange_stage_id: "1",
        unevaluated_leads: null,
        approval_pending_for_final_inspection: null,
        last_month: false,
        current_month: true,
        dashboard_redirect: false,
      }));
    } else if (value === "unevaluated") {
      setFilters((prev) => ({
        ...prev,
        page: 1,
        lead_exchange_stage_id: null,
        unevaluated_leads: 1,
        approval_pending_for_final_inspection: null,
        last_month: false,
        current_month: false,
        dashboard_redirect: false,
      }));
    } else if (value === "awaiting_inspection") {
      setFilters((prev) => ({
        ...prev,
        page: 1,
        lead_exchange_stage_id: null,
        unevaluated_leads: null,
        approval_pending_for_final_inspection: 1,
        last_month: false,
        current_month: false,
        dashboard_redirect: false,
      }));
    } else if (value && value.startsWith("stage_")) {
      const stageId = value.replace("stage_", "");
      setFilters((prev) => ({
        ...prev,
        page: 1,
        lead_exchange_stage_id: stageId,
        unevaluated_leads: null,
        approval_pending_for_final_inspection: null,
        last_month: false,
        current_month: false,
        dashboard_redirect: false,
      }));
    }

    // Update form field
    form.setFieldsValue({
      exchange_stage: value,
    });
  };

  // Get current exchange stage value for dropdown (from URL params for menu/dashboard redirects)
  const getCurrentExchangeStageValue = () => {
    // Only use URL params for menu/dashboard redirects
    if (hasMenuFilter || hotKeyId) {
      if (isUnevaluated) return "unevaluated";
      if (isApprovalPendingForFinalInspection) return "awaiting_inspection";
      if (leadExchangeStageId) {
        if (isLastMonthParam && leadExchangeStageId === "1")
          return "pending_eval_prev_month";
        if (leadExchangeStageId === "1") return "pending_eval_current_month";
        return `stage_${leadExchangeStageId}`;
      }
    }
    return undefined;
  };

  // Update exchange stage filter state when URL params change (for menu/dashboard redirects)
  useEffect(() => {
    if (hasMenuFilter || hotKeyId) {
      const value = getCurrentExchangeStageValue();
      setExchangeStageFilter(value);
    } else {
      // Reset to undefined when not from menu/dashboard
      setExchangeStageFilter(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]); // Watch entire URL search string to detect any changes

  const getTerritoryData = async () => {
    startLoading();
    try {
      const territoryData = await getFilterTerritoriesService();
      if (territoryData?.status === API_RESPONSE_CODES?.OK) {
        setTerritoryData(territoryData?.data?.data);
      }
    } catch (error) {
      setTerritoryData([]);
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    } finally {
      stopLoading();
    }
  };

  const getAreaData = async () => {
    startLoading();
    try {
      const areaData = await getFilterAreaService();
      if (areaData?.status === API_RESPONSE_CODES?.OK) {
        setAreaData(areaData?.data?.data);
      }
    } catch (error) {
      setAreaData([]);
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    } finally {
      stopLoading();
    }
  };

  const getLeadFilterDateData = async () => {
    startLoading();
    try {
      const rangeData = await getLeadFiltersLeadRange();
      if (rangeData?.status === API_RESPONSE_CODES?.OK) {
        setFollowUpData(rangeData?.data?.data);
      }
    } catch (error) {
      setAreaData([]);
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    } finally {
      stopLoading();
    }
  };

  const getLeadsTypeData = async () => {
    startLoading();
    try {
      const leadsDataArray = await getLeadService();
      if (leadsDataArray?.status === API_RESPONSE_CODES?.OK) {
        setLeadsTypeData(leadsDataArray?.data?.data);
      }
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    } finally {
      stopLoading();
    }
  };

  const getModalData = async (value) => {
    startLoading();
    try {
      const modalDataArray = await getVehicleModelService(1, true);
      if (modalDataArray?.status === API_RESPONSE_CODES?.OK) {
        setModalData(modalDataArray?.data?.data);
      }
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    } finally {
      stopLoading();
    }
  };

  const getRTOData = async () => {
    startLoading();
    try {
      const stateData = await axios.get(
        `${API_BASE_URL}/master/get-rto-locations`
      );
      if (stateData?.status === API_RESPONSE_CODES?.OK) {
        setRtoData(stateData?.data?.data);
      }
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    } finally {
      stopLoading();
    }
  };

  const getLeadListing = async (data) => {
    console.log("data3333333: ", data);
    startLoading();
    try {
      const userList = await getLeadsListingService(data);
      if (userList?.status === API_RESPONSE_CODES?.OK) {
        setLeadsData(userList?.data?.data);
        if (userTransferParams) {
          const transferIds = userList?.data?.data?.list_data?.map(
            (ele) => ele?.id
          );
          setTransferLeadIds(transferIds);
        }
      }
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    } finally {
      stopLoading();
    }
  };

  const getFuelData = async () => {
    startLoading();
    try {
      const fuelData = await axios.get(`${API_BASE_URL}/master/get-fuel-types`);
      if (fuelData?.status === API_RESPONSE_CODES?.OK) {
        setFuelData(fuelData?.data?.data);
      }
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    } finally {
      stopLoading();
    }
  };

  const onSearch = (value) => {
    setFilters((prev) => ({
      ...prev,
      page: 1,
      search: value,
      dashboard_redirect: false, // Filter changes on page should not pass dashboard_redirect
    }));
  };

  // const handlePageChange = (val) => {
  //   setFilters((state) => ({ ...state, page: val }));
  // };

  const handlePageChange = (page, pageSize) => {
    setFilters((state) => ({
      ...state,
      page: page, // Update the page
      per_page: pageSize, // Update the per_page
    }));
  };

  const handleTransferLeads = () => {
    setIsModalOpen((state) => !state);
  };

  const handleLeadDelete = async (leadData) => {
    try {
      startLoading();
      const deleteLead = await deleteLeadService(leadData?.id);
      if (deleteLead.data.status === API_RESPONSE_CODES.OK) {
        getLeadListing(filters);
        notification.success({
          message: deleteLead.data.message,
        });
      }
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    } finally {
      stopLoading();
    }
  };

  const handleCheckboxChange = (id) => {
    setTransferLeadIds((currentIds) => {
      const isIdPresent = currentIds?.includes(id);
      if (isIdPresent) {
        return currentIds?.filter((existingId) => existingId !== id);
      } else {
        return [...currentIds, id];
      }
    });
  };

  const handleViewLead = (leadId) => {
    openLeadViewInNewWindow(isAdmin, leadId);
  };

  const handleDecision = async (leadId, decision, onRefresh) => {
    try {
      const payload = {
        lead_id: leadId,
        inspection_officer_decision: decision,
      };
      const res = await approveRejectFinalInspectionService(payload);
      notification.success({ message: res?.data?.message });
      dispatch(fetchLeadDetailsServices({ id: leadId }));
      if (typeof onRefresh === "function") {
        onRefresh();
      }
    } catch (error) {
      notification.error({
        description: error?.response?.data?.message ?? error?.message,
      });
    }
  };

  // Table columns definition
  const getTableColumns = () => {
    const searchParams = new URLSearchParams(location.search);
    const awaitingInspectionTab =
      exchangeStageFilter === "awaiting_inspection" ||
      filters?.approval_pending_for_final_inspection === 1;
    const shouldShowCheckbox = isAdmin && !showRedirectTags;

    const columns = [
      ...(shouldShowCheckbox
        ? [
            {
              title: "",
              key: "checkbox",
              width: 50,
              fixed: "left",
              render: (_, record) => {
                return (
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    onMouseDown={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <Checkbox
                      checked={transferLeadIds?.includes(record?.id)}
                      onChange={(e) => {
                        e.stopPropagation();
                        handleCheckboxChange(record?.id);
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    />
                  </div>
                );
              },
            },
          ]
        : []),
      {
        title: "Lead Type",
        dataIndex: ["lead_type", "name"],
        key: "lead_type",
        width: 120,
        render: (text) => text || "-",
      },
      {
        title: "Lead No.",
        dataIndex: "id",
        key: "lead_no",
        width: 150,
        render: (text, record) => (
          <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            <span
              onClick={(e) => {
                e.stopPropagation();
                handleViewLead(record?.id);
              }}
              style={{
                cursor: "pointer",
                color: "#1890ff",
              }}
            >
              {text}
            </span>
            {record?.exchange_car === "Yes" && (
              <Tag color="gold" size="small" style={{ width: "fit-content" }}>
                Exchange Car
              </Tag>
            )}
          </div>
        ),
      },
      {
        title: "Lead Stage",
        dataIndex: ["lead_stage", "name"],
        key: "lead_stage",
        width: 120,
        render: (text) => text || "-",
      },
      {
        title: "Status",
        dataIndex: ["lead_status", "name"],
        key: "status",
        width: 120,
        render: (text, record) => {
          const isLeadDroppedOrLost =
            record?.lead_status_id === 2 || record?.lead_status_id === 3;
          const statusName = text || "-";
          const statusLower = statusName?.toLowerCase();

          // Determine color based on status
          const getStatusColor = (status) => {
            const statusLower = status?.toLowerCase();
            if (statusLower === "open") {
              return "gold"; // Yellow
            } else if (statusLower === "converted") {
              return "green";
            } else if (statusLower === "lost" || statusLower === "dropped") {
              return "red";
            } else if (
              statusLower === "refunded" ||
              statusLower === "cancelled"
            ) {
              return "orange";
            }
            return "default"; // Default color for other statuses
          };

          const statusColor = getStatusColor(statusName);

          // Show tooltip for lost, dropped, cancelled, or refunded status with remarks
          const shouldShowTooltip =
            (isLeadDroppedOrLost ||
              statusLower === "cancelled" ||
              statusLower === "refunded") &&
            record?.lead_status_remark_detail?.reason_detail?.length > 0;

          if (shouldShowTooltip) {
            return (
              <Tooltip
                title={
                  <ul style={{ margin: 0, paddingLeft: 20 }}>
                    {record.lead_status_remark_detail.reason_detail.map(
                      (ele, index) => (
                        <li key={index}>{ele}</li>
                      )
                    )}
                  </ul>
                }
              >
                <Tag color={statusColor}>{statusName}</Tag>
              </Tooltip>
            );
          }
          return <Tag color={statusColor}>{statusName}</Tag>;
        },
      },
      {
        title: "Allocation Status",
        dataIndex: "allocation_status",
        key: "allocation_status",
        width: 180,
        render: (text) => {
          if (!text || text === null || text === undefined) {
            return "-";
          }
          // Determine color based on allocation status text
          const getAllocationStatusColor = (status) => {
            const statusLower = String(status)?.toLowerCase().trim();

            if (statusLower === "no allocation requests") {
              return "default";
            } else if (statusLower === "request pending") {
              return "gold";
            } else if (statusLower === "approved") {
              return "green";
            } else if (statusLower === "rejected") {
              return "red";
            } else if (statusLower === "cancellation requested") {
              return "orange";
            } else if (statusLower === "cancellation approved") {
              return "blue";
            }

            // Fallback for partial matches
            if (statusLower.includes("approved")) {
              return "green";
            } else if (statusLower.includes("pending")) {
              return "gold";
            } else if (statusLower.includes("rejected")) {
              return "red";
            } else if (statusLower.includes("cancellation")) {
              return statusLower.includes("requested") ? "orange" : "blue";
            }

            return "default";
          };
          const statusColor = getAllocationStatusColor(text);
          return <Tag color={statusColor}>{text}</Tag>;
        },
      },
      {
        title: "Lead Owner",
        dataIndex: ["lead_assignee", "full_name"],
        key: "lead_owner",
        width: 150,
        render: (text) => text || "-",
      },
      {
        title: "Vehicle",
        key: "vehicle",
        width: 200,
        render: (_, record) => {
          const model = record?.vehicle_detail?.model?.model_name || "";
          const fuel = record?.vehicle_detail?.fuel_type?.title || "";
          const color = record?.vehicle_detail?.color?.color || "";
          return (
            `${model}${fuel ? `-${fuel}` : ""}${color ? `-${color}` : ""}` ||
            "-"
          );
        },
      },
      {
        title: "Customer",
        key: "customer",
        width: 180,
        render: (_, record) => {
          const name = record?.customer?.full_name || "";
          if (isBackOfficeManager) {
            return name || "-";
          }
          const phone = record?.customer?.phone_no || "";
          return name && phone ? `${name}, ${phone}` : name || phone || "-";
        },
      },
      ...(isBackOfficeManager
        ? []
        : [
            {
              title: "Address",
              dataIndex: ["customer", "address"],
              key: "address",
              width: 200,
              render: (text) => text || "-",
            },
          ]),
      {
        title: "Added On",
        dataIndex: "created_at",
        key: "added_on",
        width: 120,
        render: (text) => (text ? ddmmyyFormatter(text) : "-"),
      },
      {
        title: "Next Follow Up",
        dataIndex: "next_follow_up_date",
        key: "next_follow_up",
        width: 140,
        render: (text) => (text ? ddmmyyFormatter(text) : "-"),
      },

      {
        title: "Action",
        key: "action",
        width: awaitingInspectionTab ? 240 : 150,
        className: "sticky-action-column",
        fixed: "right",
        render: (_, record) => {
          const showApprovalButtons =
            record?.awaiting_inspection_status === true &&
            record?.exchange_vehicle_detail?.inspection_officer_decision === 0;
          const hasViewLeadPermission = isAdmin
            ? true
            : permissions?.includes("view-lead");
          const hasDeleteLeadPermission = isAdmin
            ? true
            : permissions?.includes("delete-lead");

          // These roles can always view leads
          const restrictedRoles = [
            "Back Office Manager",
            "Finance Manager",
            "Head Office Manager",
          ];
          const isRestrictedRole = restrictedRoles.includes(roleType);
          const canViewLead = isRestrictedRole || hasViewLeadPermission;

          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                flexWrap: "nowrap",
              }}
              onClick={(e) => e.stopPropagation()}
              onMouseDown={(e) => e.stopPropagation()}
            >
              {canViewLead && (
                <Button
                  type="text"
                  size="small"
                  icon={<EyeFilled />}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleViewLead(record?.id);
                  }}
                  style={{ pointerEvents: "auto" }}
                />
              )}
              {hasDeleteLeadPermission && (
                <Popconfirm
                  title="Are you sure you want to delete this lead?"
                  onConfirm={(e) => {
                    e.stopPropagation();
                    handleLeadDelete(record);
                  }}
                  onCancel={(e) => {
                    e.stopPropagation();
                  }}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button
                    type="text"
                    size="small"
                    danger
                    icon={<DeleteOutlined />}
                    onClick={(e) => e.stopPropagation()}
                    style={{ pointerEvents: "auto" }}
                  />
                </Popconfirm>
              )}
              {showApprovalButtons && (
                <>
                  <Button
                    size="small"
                    type="primary"
                    style={{
                      backgroundColor: "#0a9551",
                      borderColor: "#0a9551",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDecision(record?.id, 1, () =>
                        getLeadListing(filters)
                      );
                    }}
                  >
                    Approve
                  </Button>
                  <Button
                    size="small"
                    danger
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDecision(record?.id, 2, () =>
                        getLeadListing(filters)
                      );
                    }}
                  >
                    Reject
                  </Button>
                </>
              )}
            </div>
          );
        },
      },
    ];

    return columns;
  };

  return (
    <>
      <Loader loading={isLoading} />
      <div className="user-data">
        <div className="search-leads">
          {showRedirectTags ? (
            ""
          ) : (
            <Row gutter={[16, 16]} align="end">
              <Col xl={9} lg={10} md={24} sm={24} xs={24}>
                <div className="user-right d-flex align-items-center justify-content-end leads-btn">
                  <Space size="middle">
                    {hasAddLeadPermission && (
                      <Link to={isAdmin ? `${route}/leads/add` : `/leads/add`}>
                        <Button type="primary" className="secondary-button"  icon={<PlusOutlined />}
                                         >
                          Add New Lead
                        </Button>
                      </Link>
                    )}
                  </Space>
                  {isAdmin && (
                    <Space size="middle">
                      <Button
                        type="primary"
                        className="secondary-button ms-3"
                        onClick={handleTransferLeads}
                        disabled={!selectedLeadsLength}
                      >
                        Transfer Lead
                      </Button>
                    </Space>
                  )}
                </div>
              </Col>
            </Row>
          )}
          <div>
            <Card className="mt-4">
              {showRedirectTags || userTransferParams ? (
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
                  <Space size={"middle"} wrap>
                    {Object.entries(tagNames)?.map(([key, value]) => (
                      <Space key={key}>
                        {/* Adding a key for each pair for React's rendering */}
                        <span className="tag-label">{key}:</span>
                        <Tag color="green">{value}</Tag>
                      </Space>
                    ))}
                  </Space>
                  {userTransferParams ? (
                    ""
                  ) : (
                    <Button
                      type="primary"
                      className="secondary-button"
                      onClick={handleButtonClick}
                    >
                      Go to Leads List
                    </Button>
                  )}
                </div>
              ) : (
                <Form
                  form={form}
                  layout="vertical"
                  name="normal_search"
                  className="login-form"
                  initialValues={{
                    remember: true,
                  }}
                >
                  {userTransferParams ? (
                    ""
                  ) : (
                    <div className="login-input-field">
                      <Row gutter={[16, 0]}>
                        <Col xl={4} lg={6} md={6} sm={24} xs={24}>
                          <Form.Item label="Search">
                            <Search
                              allowClear
                              onSearch={onSearch}
                              placeholder={
                                isBackOfficeManager
                                  ? "Search by Customer"
                                  : "Search by Customer and Contact Number"
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col xl={4} lg={6} md={6} sm={24} xs={24}>
                          <Form.Item label="Date Range" name="date">
                            <RangePicker
                              format="DD/MM/YYYY"
                              className="form-control-ant"
                              value={
                                filters?.start_date && filters?.end_date
                                  ? [dayjs(filters.start_date), dayjs(filters.end_date)]
                                  : null
                              }
                              onChange={(dates) =>
                                setFilters((state) => ({
                                  ...state,
                                  page: 1,
                                  start_date:
                                    dates && dates[0]
                                      ? dates[0].format("YYYY-MM-DD")
                                      : "",
                                  end_date:
                                    dates && dates[1]
                                      ? dates[1].format("YYYY-MM-DD")
                                      : "",
                                  dashboard_redirect: false,
                                }))
                              }
                            />
                          </Form.Item>
                        </Col>

                        <Col xl={4} lg={6} md={6} sm={24} xs={24}>
                          <Form.Item label=" Lead Status" name="lead_status">
                            <Select
                              allowClear
                              // showSearch
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              mode="multiple"
                              maxTagCount={2}
                              placeholder="Status"
                              className="form-control-ant"
                              onChange={(ele) =>
                                setFilters((state) => ({
                                  ...state,
                                  page: 1,
                                  lead_status: ele,
                                  dashboard_redirect: false, // Filter changes on page should not pass dashboard_redirect
                                }))
                              }
                            >
                              {leadStatusData?.map((option) => (
                                <Select.Option
                                  key={option.id}
                                  value={option.slug}
                                >
                                  {option.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>

                        <Col xl={4} lg={6} md={6} sm={24} xs={24}>
                          <Form.Item label="Lead Type" name="lead_type">
                            <Select
                              allowClear
                              mode="multiple"
                              maxTagCount={2}
                              placeholder="Lead Type"
                              className="form-control-ant"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              onChange={(ele) =>
                                setFilters((state) => ({
                                  ...state,
                                  page: 1,
                                  lead_type: ele,
                                  dashboard_redirect: false, // Filter changes on page should not pass dashboard_redirect
                                }))
                              }
                            >
                              {leadsTypeData?.map((option) => (
                                <Select.Option
                                  key={option.id}
                                  value={option.id}
                                >
                                  {option.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>

                        <Col xl={4} lg={6} md={6} sm={24} xs={24}>
                          <Form.Item label="Model Type" name="model_type">
                            <Select
                              allowClear
                              mode="multiple"
                              maxTagCount={2}
                              placeholder="Model Type"
                              className="form-control-ant"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              onChange={handleModalIdChange}
                            >
                              {modalData?.map((option) => (
                                <Select.Option
                                  key={option.id}
                                  value={option.id}
                                >
                                  {option?.model_name}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>

                        <Col xl={4} lg={6} md={6} sm={24} xs={24}>
                          <Form.Item label="Fuel Type" name="fuel_type">
                            <Select
                              allowClear
                              mode="multiple"
                              maxTagCount={2}
                              placeholder="Fuel Type"
                              className="form-control-ant"
                              // disabled={!vehicleIds?.variant_id}
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              onChange={(ele) =>
                                setFilters((state) => ({
                                  ...state,
                                  page: 1,
                                  fuel_type: ele,
                                  dashboard_redirect: false, // Filter changes on page should not pass dashboard_redirect
                                }))
                              }
                            >
                              {fuelData &&
                                fuelData?.map((option) => (
                                  <Select.Option
                                    key={option.id}
                                    value={option.id}
                                  >
                                    {option?.title}
                                  </Select.Option>
                                ))}
                            </Select>
                          </Form.Item>
                        </Col>

                        <Col xl={4} lg={6} md={6} sm={24} xs={24}>
                          <Form.Item label="RTO" name="rto_locations">
                            <Select
                              allowClear
                              mode="multiple"
                              maxTagCount={2}
                              placeholder="RTO"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              className="form-control-ant"
                              onChange={
                                (ele) =>
                                  setFilters((state) => ({
                                    ...state,
                                    page: 1,
                                    rto_locations: ele,
                                    dashboard_redirect: false, // Filter changes on page should not pass dashboard_redirect
                                  }))
                                // disabled={register.state_id === 0}
                              }
                            >
                              {rtoData?.map((option) => (
                                <Option key={option.id} value={option.id}>
                                  {option.name}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>

                        <Col xl={4} lg={6} md={6} sm={24} xs={24}>
                          <Form.Item
                            name="territory_id"
                            label="Territory"
                            rules={[
                              {
                                required: false,
                                message: "Please select your territory",
                              },
                            ]}
                          >
                            <Select
                              allowClear
                              mode="multiple"
                              maxTagCount={2}
                              // disabled={register.state_id === 0}
                              placeholder="Territory"
                              className="form-control-ant"
                              onChange={handleTerritoryChange}
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                            >
                              {territoryData?.map((option) => (
                                <Select.Option
                                  key={option.id}
                                  value={option.id}
                                >
                                  {option?.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>

                        <Col xl={4} lg={6} md={6} sm={24} xs={24}>
                          <Form.Item
                            name="area_id"
                            label="Area"
                            rules={[
                              {
                                required: false,
                                message: "Please select your area",
                              },
                            ]}
                          >
                            <Select
                              allowClear
                              mode="multiple"
                              maxTagCount={2}
                              placeholder="Area"
                              className="form-control-ant"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              onChange={(ele) =>
                                setFilters((state) => ({
                                  ...state,
                                  page: 1,
                                  area_id: ele,
                                  dashboard_redirect: false, // Filter changes on page should not pass dashboard_redirect
                                }))
                              }
                              // disabled={reFgister.territory_id === 0}
                            >
                              {areaData?.map((option) => (
                                <Select.Option
                                  key={option.id}
                                  value={option.id}
                                >
                                  {option?.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>

                        <Col xl={4} lg={6} md={6} sm={24} xs={24}>
                          <Form.Item label="Lead Owner" name="lead_owned">
                            <Select
                              allowClear
                              mode="multiple"
                              maxTagCount={2}
                              placeholder="Lead Owner"
                              className="form-control-ant"
                              filterOption={(input, option) =>
                                option.children
                                  ?.join(" ")
                                  ?.toLowerCase()
                                  ?.indexOf(input?.toLowerCase()) >= 0
                              }
                              onChange={(ele) =>
                                setFilters((state) => ({
                                  ...state,
                                  page: 1,
                                  lead_owned: ele,
                                  dashboard_redirect: false, // Filter changes on page should not pass dashboard_redirect
                                }))
                              }
                            >
                              {ownerData?.map((option) => (
                                <Select.Option
                                  key={option.id}
                                  value={option.id}
                                >
                                  {option?.full_name}
                                  {option?.title ? ` (${option?.title})` : ""}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>

                        <Col xl={4} lg={6} md={6} sm={24} xs={24}>
                          <Form.Item label="Lead Stage" name="lead_stage">
                            <Select
                              allowClear
                              mode="multiple"
                              maxTagCount={2}
                              placeholder="Lead Stage"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              className="form-control-ant"
                              onChange={(ele) =>
                                setFilters((state) => ({
                                  ...state,
                                  page: 1,
                                  lead_stage: ele,
                                  dashboard_redirect: false, // Filter changes on page should not pass dashboard_redirect
                                }))
                              }
                            >
                              {leadStageData?.map((option) => (
                                <Select.Option
                                  key={option.id}
                                  value={option.id}
                                >
                                  {option?.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>

                        <Col xl={4} lg={6} md={6} sm={24} xs={24}>
                          <Form.Item label="Lead Source" name="lead_source">
                            <Select
                              allowClear
                              mode="multiple"
                              maxTagCount={2}
                              placeholder="Lead Source"
                              className="form-control-ant"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              onChange={(ele) =>
                                setFilters((state) => ({
                                  ...state,
                                  page: 1,
                                  lead_sources: ele,
                                  dashboard_redirect: false, // Filter changes on page should not pass dashboard_redirect
                                }))
                              }
                            >
                              {enquiryData?.map((option) => (
                                <Select.Option
                                  key={option.id}
                                  value={option.id}
                                >
                                  {option?.source}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>

                        <Col xl={4} lg={6} md={6} sm={24} xs={24}>
                          <Form.Item
                            label="Follow Up Date"
                            name="follow_up_date_id"
                          >
                            <Select
                              allowClear
                              mode="multiple"
                              maxTagCount={2}
                              placeholder="Follow Up Date"
                              className="form-control-ant"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              onChange={(ele) =>
                                setFilters((state) => ({
                                  ...state,
                                  page: 1,
                                  follow_up_date_id: ele,
                                  dashboard_redirect: false, // Filter changes on page should not pass dashboard_redirect
                                }))
                              }
                            >
                              {followUpData?.map((option) => (
                                <Select.Option
                                  key={option.id}
                                  value={option.id}
                                >
                                  {option?.title}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>

                        <Col xl={4} lg={6} md={6} sm={24} xs={24}>
                          <Form.Item
                            label="Allocation Status"
                            name="allocation_status"
                          >
                            <Select
                              allowClear
                              placeholder="Allocation Status"
                              className="form-control-ant"
                              onChange={(ele) =>
                                setFilters((state) => ({
                                  ...state,
                                  page: 1,
                                  allocation_status: ele,
                                  dashboard_redirect: false, // Filter changes on page should not pass dashboard_redirect
                                }))
                              }
                            >
                              <Select.Option value={0}>
                                No Allocation Requests
                              </Select.Option>
                              <Select.Option value={1}>
                                Request Pending
                              </Select.Option>
                              <Select.Option value={2}>Approved</Select.Option>
                              <Select.Option value={3}>Rejected</Select.Option>
                              <Select.Option value={4}>
                                Cancellation Requested
                              </Select.Option>
                              <Select.Option value={5}>
                                Cancellation Approved
                              </Select.Option>
                            </Select>
                          </Form.Item>
                        </Col>

                        <Col xl={4} lg={6} md={6} sm={24} xs={24}>
                          <Form.Item
                            label="Exchange Stages"
                            name="exchange_stage"
                          >
                            <Select
                              allowClear
                              placeholder="Exchange Stages"
                              className="form-control-ant"
                              value={exchangeStageFilter}
                              onChange={handleExchangeStageChange}
                            >
                              <Select.Option value="pending_eval_prev_month">
                                Pending for Evaluation (Prev Month)
                              </Select.Option>
                              <Select.Option value="pending_eval_current_month">
                                Pending for Evaluation (Current Month)
                              </Select.Option>
                              {exchangeStages
                                .filter((stage) => stage.id !== 1)
                                .map((stage) => (
                                  <Select.Option
                                    key={stage.id}
                                    value={`stage_${stage.id}`}
                                  >
                                    {stage.name}
                                  </Select.Option>
                                ))}
                              {shouldShowUnallocated() && (
                                <Select.Option value="unevaluated">
                                  Unevaluated
                                </Select.Option>
                              )}
                              {(roleType === "Exchange Evaluation Team" ||
                                roleType === "Procurement Manager" ||
                                roleType === "Super Admin") && (
                                <Select.Option value="awaiting_inspection">
                                  Awaiting Inspection Approvals
                                </Select.Option>
                              )}
                            </Select>
                          </Form.Item>
                        </Col>

                        <Col xl={4} lg={6} md={6} sm={24} xs={24}>
                          <Form.Item label="File Stage" name="file_stage">
                            <Select
                              allowClear
                              placeholder="File Stage"
                              className="form-control-ant"
                              onChange={(ele) =>
                                setFilters((state) => ({
                                  ...state,
                                  page: 1,
                                  file_stage_id: ele,
                                  dashboard_redirect: false, // Filter changes on page should not pass dashboard_redirect
                                }))
                              }
                            >
                              {fileStageData?.map((option) => (
                                <Select.Option
                                  key={option.id}
                                  value={option.id}
                                >
                                  {option?.stage_name}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  )}
                </Form>
              )}
            </Card>

            <div className="taglist pt-4 text-start">
              {/* <Tag closeIcon onClose={preventDefault} className="user-tags mb-4">
              Open
            </Tag> */}
            </div>
            <div className="lead-type-card">
              <Table
                columns={getTableColumns()}
                dataSource={
                  hasLeadsData
                    ? leadsData?.list_data?.map((item) => ({
                        ...item,
                        key: item.id,
                      }))
                    : []
                }
                loading={isLoading}
                pagination={{
                  current: filters?.page,
                  total: leadsData?.total_records || 0,
                  pageSize: filters?.per_page,
                  showSizeChanger: true,
                  showTotal: (total, range) =>
                    `${range[0]}-${range[1]} of ${total} leads`,
                  onChange: (page, pageSize) =>
                    handlePageChange(page, pageSize),
                  onShowSizeChange: (current, size) =>
                    handlePageChange(current, size),
                }}
                scroll={{
                  x: "max-content", // 🟢 makes it responsive horizontally
                }}
                locale={{
                  emptyText: <NoDataFound />,
                }}
              />
            </div>
            <ModalComponent
              filters={filters}
              setFilters={setFilters}
              isModalOpen={isModalOpen}
              territoryData={territoryData}
              setIsModalOpen={setIsModalOpen}
              getLeadListing={getLeadListing}
              transferLeadIds={transferLeadIds}
              leadsInitialState={leadsInitialState}
              userTransferParams={userTransferParams}
              setTransferLeadIds={setTransferLeadIds}
              selectedLeadsLength={selectedLeadsLength}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Leads;
